<template>
  <div class="agent-showContract">
    <nav-bar titleText="电子合同" titleWeight="bold" @goBack="goBack"></nav-bar>
    <div class="stepper-warpper">
      <van-stepper
        v-model="value"
        input-width="40px"
        step="0.2"
        :decimal-length="1"
        :disabled="isDisabled"
        @change="stepperOnchange"
      />
      <div class="percent">{{percentValue}}</div>
    </div>
    <div class="contentBox">
      <div id="contidract" :style="contidractStyle">
        <div :style="pdfStyle" ref="pdfbox">
          <pdf v-for="i in numPages" :key="i" :src="pdfSrc" :page="i" ></pdf>
        </div>
        <!-- <img src="http://others-qiniu.shall-buy.com/others-icon-20201014210705994158.jpg" class="img" alt=""> -->
        <div v-if="Array.isArray(pdfSrc)">
          <img v-for="(item, i) in pdfSrc" :src="item" class="img" :key="i" :style="imgStyle">
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import navBar from "../components/navBar";
import axios from "axios";
import pdf from "vue-pdf";
import CMapReaderFactory from 'vue-pdf/src/CMapReaderFactory.js';
export default {
  name: "agentShowContract",
  data() {
    return {
      // node_modules\vue-pdf\node_modules\pdfjs-dist\es5\build\pdf.worker.js
      contidractStyle: {'background-color': '#E3E3E3', height: '0'},
      pdfSrc: "",
      numPages: undefined,
      value: 1,
      pdfStyle: {'transform-origin': 'left top'},
      imgStyle: {width: '100%'},
      isDisabled: false,
    };
  },
  created() {
    if (this.$route.query.token) {
      this.$api.setToken(this.$route.query.token);
    }
    this.onLoad();
  },
  mounted: function () {
    this.contidractStyle.height = document.body.clientHeight - (88 + 28) + 'px'
  },
  computed: {
    percentValue(){
      return parseInt(parseFloat(this.value)*100) + '%'
    },
  },
  components: {
    navBar,
    pdf,
  },
  methods: {
    stepperOnchange(){
      this.$nextTick(() => {
        // this.pdfStyle.width = this.percentValue
        this.pdfStyle.transform = `scale(${this.value})`
        this.imgStyle.width = this.percentValue
        // 刷新pdf整体容器，解决IOS放大缩小后的样式混乱BUG
        this.$refs.pdfbox.style.display = 'none'
        this.isDisabled = true
        setTimeout(() => {
          // 刷新pdf整体容器，解决IOS放大缩小后的样式混乱BUG
          this.$refs.pdfbox.style.display = 'block'
        },10)
        setTimeout(() => {
          this.isDisabled = false
        },200)
      })
    },
    goBack() {
      // this.params("", "", "goBack"); 
      this.$router.go(-1);
    },
    async onLoad() {
      try {
        this.pdfSrc = this.$route.query.agent_contract_url
        // 如果有图片合同，就不用往下走了，往下走是去请求pdf合同
        if (this.pdfSrc && this.pdfSrc.length) return
        const res = await this.$api.post("/contract/member/contract/info", {contract_id: this.$route.query.agent_contract_id})
        this.pdfSrc =  location.protocol+'//'+res.sign_file_url.split('//')[1];
        if (this.pdfSrc) {
          this.pdfSrc = pdf.createLoadingTask({url: this.pdfSrc, CMapReaderFactory});
          this.pdfSrc.promise.then((pdf) => {
            this.numPages = pdf.numPages;
            console.log(this.numPages);
          });
        }
      } catch (err) {
        console.log(err)
      }
    },
    
  },
};
</script>
<style lang="less">
.agent-showContract {
  padding-top: 88px;
  background-color: #f5f6f7;
  font-size: 16px;
  overflow: hidden;
  #contidract {
    overflow: scroll;
  }
  .stepper-warpper {
    height: 28px;
    position: relative;
    background-color: #fff;
    .van-stepper {
      position: absolute;
      left: 50%;
      transform: translateX(-50%);
    }
    .percent {
      position: absolute;
      height: 28px;
      line-height: 28px;
      width: 40px;
      top: 0;
      left: 50%;
      transform: translateX(-50%);
      text-align: center;
      background-color: #f2f3f5;
      font-size: 13px;
    }
  }
}
</style>
